import script from "./LoginTopService.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginTopService.vue?vue&type=script&setup=true&lang=ts"

import "./LoginTopService.vue?vue&type=style&index=0&id=64de8a14&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64de8a14"]])

export default __exports__